import { createContext } from 'react';

const DrinksContext = createContext();

export default DrinksContext;
